<template>
  <div class="min-w-[800px]">
    <button
      class="accordion md-layout"
      :class="{ 'bg-light': isDisplay }"
      @click="toggleList"
    >
      <span class="md-layout-item md-size-43"
        >{{ termData.name }} ({{
          convertDate(termData.start_date, termData.end_date)
        }})
      </span>
      <span class="md-layout-item md-size-30"
        >{{ $t("student.instructional_days") }}:
        {{ termData.instructional_pass_days }} /
        {{ termData.instructional_days }}
      </span>
      <span class="md-layout-item md-size-25 text-[#08980E]"
        >P: {{ termData.present_days }}</span
      >
      <span :class="isDisplay ? 'triangle-up' : 'triangle-down'"></span>
    </button>
    <div class="panel" v-if="!isDisplay">
      <div class="line-gray-outsize"></div>
      <div class="line-gray-insize"></div>
      <single-class
        v-for="(classData, idx) in termData.classes"
        :key="idx + 'class'"
        :classData="classData"
      >
      </single-class>
    </div>
  </div>
</template>
<script>
import { convertDateFromServer } from "../../../../../helpers/datetime-helper";
import SingleClass from "./SingleClass";
export default {
  components: { SingleClass },
  props: ["termData"],
  data() {
    return {
      isDisplay: true
    };
  },
  methods: {
    toggleList() {
      this.isDisplay = !this.isDisplay;
    },
    convertDate(startDate, endDate) {
      return `${convertDateFromServer(startDate, "date")} ${this.$t(
        "common.to"
      )} ${convertDateFromServer(endDate, "date")}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.accordion {
  min-width: 650px;
  background-color: rgba(#616871, 0.1);
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  text-align: left;
  outline: none;
  transition: 1s;
  border-radius: 100px;
  border: 2px solid #ccc;
  margin: 5px 0 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  .triangle-up {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 14px solid #555;
  }
  .triangle-down {
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 14px solid #555;
  }
}

.bg-light {
  background-color: #dee2e6;
}
.accordion:hover {
  background-color: rgba(#616871, 0.1);
  border-radius: 100px;
}

.panel {
  margin-left: 15px;
  overflow: hidden;
  position: relative;
  .line-gray-outsize {
    left: 50px;
    top: -15px;
    width: 1px;
    height: calc(100% - 40px);
    z-index: -1;
    background: #ccc;
    position: absolute;
  }
  .line-gray-insize {
    left: 0px;
    top: -15px;
    width: 1px;
    height: calc(100% + 60px);
    z-index: -1;
    background: #ccc;
    position: absolute;
  }
}
</style>
